import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';

import {
  TellentAdoptedStylesheetsDirective,
  TellentAppShellComponent,
  TellentThemeDirective,
} from '@core/tellent-smart-ui';
import { InputSignalLike, TellentWebComponent } from '@core/tellent-types';

@Component({
  selector: 'x-app-shell',
  template: `
    <tlc-app-shell
      [isMobile]="isMobile()"
      [isMinimalLayout]="isMinimalLayout()"
      [shouldExpandNavOnHover]="shouldExpandNavOnHover()"
    >
      <ng-container ngProjectAs="banner">
        <slot name="banner"></slot>
      </ng-container>

      <ng-container ngProjectAs="topbar-start-label">
        <slot name="topbar-start-label"></slot>
      </ng-container>

      <ng-container ngProjectAs="topbar-center">
        <slot name="topbar-center"></slot>
      </ng-container>

      <ng-container ngProjectAs="topbar-end">
        <slot name="topbar-end"></slot>
      </ng-container>

      <ng-container ngProjectAs="settings-topbar-center">
        <slot name="settings-topbar-center"></slot>
      </ng-container>

      <ng-container ngProjectAs="settings-topbar-end">
        <slot name="settings-topbar-end"></slot>
      </ng-container>

      <ng-container ngProjectAs="main">
        <slot name="main"></slot>
      </ng-container>

      <ng-container ngProjectAs="bottom-bar">
        <slot name="bottom-bar"></slot>
      </ng-container>
    </tlc-app-shell>
  `,
  styleUrls: ['../../../styles.less'],
  styles: `
    :host {
      display: contents;
    }
  `,
  hostDirectives: [TellentThemeDirective, TellentAdoptedStylesheetsDirective],
  imports: [TellentAppShellComponent],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TellentAppShellWrapComponent {
  // NOTE: debug purposes, leave it for now
  // @ts-ignore
  // public isMobile = signal(
  //   JSON.parse(new URLSearchParams(location.href.split('?').pop()).get('mobile')!),
  // );

  private readonly elementRef = inject(ElementRef<HTMLElement>);

  public isMobile: InputSignalLike<boolean> = input<boolean>(
    this.getAttributeValue('isMobile') === 'true',
  );

  public isMinimalLayout: InputSignalLike<boolean> = input<boolean>(
    this.getAttributeValue('isMinimalLayout') === 'true',
  );

  public shouldExpandNavOnHover: InputSignalLike<boolean> = input<boolean>(
    this.getAttributeValue('shouldExpandNavOnHover') === 'true',
  );

  private getAttributeValue(attrName: string): string | null {
    return this.elementRef.nativeElement.attributes.getNamedItem(attrName)?.value ?? null;
  }
}

export type TellentAppShellWebComponent = TellentWebComponent<
  TellentAppShellWrapComponent,
  'isMobile' | 'isMinimalLayout' | 'shouldExpandNavOnHover'
>;
